@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="justify-all">
      <img class="safety-logo" src="../../../assets/images/safety_2_logo_white.svg"/>
      <mat-card appearance="outlined" class="login-card">
        <img class="topLeft-inCard" src="../../../assets/images/SAFETY-CORNER.svg"/>
        <mat-card-header class="no-text-margin center-header" style="margin: 0 auto">
          <h2>{{ 'safety²-EHS Software' }}</h2>
        </mat-card-header>
        <mat-card-subtitle style="text-align: center">
          <h3>{{ 'Open Login' }}</h3>
        </mat-card-subtitle>
        <mat-card-content>
          <div class="block-fields">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>{{ 'firstName' | translate }}</mat-label>
              <input type="text" matInput formControlName="externalEmployeeFirstName" required>
            </mat-form-field>
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>{{ 'name' | translate }}</mat-label>
              <input type="text" matInput formControlName="externalEmployeeName" required>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'email' | translate }}</mat-label>
              <input type="text" matInput formControlName="email">
            </mat-form-field>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'company' | translate }}</mat-label>
              <input type="text" matInput formControlName="externalCompanyName" required>
            </mat-form-field>
            <saf-language-select class="full-width"  formControlName="language"></saf-language-select>
            <!--          <saf-language-select (valueChange)="changeLanguage($event)" class="full-width"-->
          <!--                               formControlName="languageId"></saf-language-select>-->
        </div>
        <div fxLayoutAlign="center">
          <button class="half-width button-color" fxFlex="0 0 calc(50% - 4px)" mat-raised-button
          type="submit" color="primary">{{ 'login' | translate }}</button>
        </div>
      </mat-card-content>
      <img class="bottomRight-inCard" src="../../../assets/images/SAFETY-CORNER.svg"/>
    </mat-card>
    <div class="company-logo"></div>
  </div>
</form>
}
